enum Environment {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  PRODUCTION = 'production'
}

const BaseUrl: { [key: string]: string } = {
  [Environment.LOCAL]: 'http://localhost:8000',
  // [Environment.LOCAL]: 'https://betaapi.ocdfeat.com',
  [Environment.DEVELOPMENT]: 'https://betaapi.ocdfeat.com',
  [Environment.PRODUCTION]: 'https://api.ocdfeat.com'
};

const AppUrl: { [key: string]: string } = {
  [Environment.LOCAL]: 'http://localhost:3000',
  // [Environment.LOCAL]: 'https://betaapp.ocdfeat.com',
  [Environment.DEVELOPMENT]: 'https://betaapp.ocdfeat.com',
  [Environment.PRODUCTION]: 'https://app.ocdfeat.com'
};

function getEnv() {
  return import.meta.env.VITE_APP_ENV ?? Environment.LOCAL;
}

const AppConfig = {
  apiBaseUrl: BaseUrl[getEnv()],
  appUrl: AppUrl[getEnv()],
  environment: getEnv(),
  FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
};

export { Environment, AppConfig };
